var Humm = (function (endpoint) {
    var animationClass = 'processing-animation';
    var _selectorID;
    var $hummEl;
    var $payButtonEl;
    var pending = false;
    var currentTotal = null;
    
    function UpdateHumm(model) {

        var total = model.get('Total');
        if (total && total !== currentTotal) {
            currentTotal = total;
            $hummEl.find('script').remove();
            var script = $('<script>',
                {
                    src: 'https://widgets.shophumm.com.au/content/scripts/price-info.js?element=%23' +
                        _selectorID +
                        '&productPrice=' +
                        total +
                        '&length=short'
                });

            $('.remodal-wrapper').remove();

            var currentWidget = $hummEl.find('.checkout-humm-wrapper .humm-price-info-widget');
            currentWidget.remove();
            $('@hummLoading').removeClass('hidden-block');

            var interval = setInterval(function() {
                var el = $hummEl.find('.checkout-humm-wrapper .humm-price-info-widget');
                if (el.length) {
                    $('@hummLoading').addClass('hidden-block');
                    clearInterval(interval);
                }
                if (el.length > 1) {
                    el[0].remove();
                }
            },
            200);
            
            script.appendTo($hummEl);
            $hummEl.removeClass('hidden-block');
        } else {
            $hummEl.addClass('hidden-block');
        }
    }

    function SubmitForm(formData) {
        var formTemplate = '<form action="' + endpoint + '" name="humm" method="post" class="hidden-block">[[inputs]]<br/><input type="submit" value="Pay"></form>';
        var inputTemplate = '<div>[[Key]]: <input type="text" name="[[Key]]" value="[[Value]]" /></div>';
        var inputs = [];

        for (var key in formData) {
            inputs.push(inputTemplate.replace(/\[\[Key\]\]/gi, key).replace('[[Value]]', formData[key]));
        }

        var form = $(formTemplate.replace('[[inputs]]', inputs.join('')));

        $('body').append(form);
        form.submit();
    }

    return {
        init: function(selectorID, summaryModel, prePayment, buttonOnly) {
            if (GlobalSettings.HummEnabled || true) {
                
                _selectorID = selectorID;

                var el;
                if (buttonOnly) {
                    el = $.tmpl('humm-button', { selector: selectorID });
                }
                else {
                    el = $.tmpl('humm-container', { selector: selectorID });
                }

                $('#' + selectorID).replaceWith(el);

                $hummEl = el;
                $payButtonEl = buttonOnly ? el : el.find('@btnHumm');

                $payButtonEl.on('click', function() {
                    if (prePayment && !pending) {
                        pending = true;
                        $payButtonEl.addClass(animationClass);
                        prePayment()
                            .done(function(request) {
                                if (window.app && app.event && app.event.humm) {
                                    app.event.humm();
                                }
                                SubmitForm(request.Value);
                            })
                            .always(function() {
                                pending = false;
                                $payButtonEl.removeClass(animationClass);
                            });
                    }
                });
                if (!buttonOnly) {
                    summaryModel.on('change', UpdateHumm);
                    UpdateHumm(summaryModel);
                }
                return $hummEl;
            }
            return null;
        },
        toggle: function(value) {
            $hummEl.toggleClass('hidden-block', !value);
        }
    }

});